import request from '../../utils/request'
import qs from 'qs'
import { GETUSERINFO, GETUSERLIST } from '../constants'

/**
 * 获取用户列表
 * @param {*} params
 * @returns
 */
export const getUserList = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/comp/user/', {
      params,
    })
    dispatch({
      type: GETUSERLIST,
      payload: res.data.data,
    })
  }
}

/**
 * 获取用户信息
 * @param {*} id
 * @returns
 */
export const getUserInfo = (id) => {
  return async (dispatch) => {
    const res = await request.get(`sys/comp/user/${id}/`)
    // console.log(res)
    dispatch({
      type: GETUSERINFO,
      payload: res.data.data,
    })
  }
}

/**
 * 新增用户
 * @param {*} values
 * @returns
 */
export const addUser = (values) => {
  return async (dispatch) => {
    const res = await request.post('sys/comp/user/', values)
    console.log(res)
  }
}

/**
 * 修改用户
 * @param {*} values
 * @returns
 */
export const editUser = (values) => {
  return async (dispatch) => {
    const res = await request.put(`sys/comp/user/${values.emp_id}/`, values)
    console.log(res)
  }
}

/**
 * 删除用户
 * @param {*} id
 * @returns
 */
export const delUsers = (id) => {
  return async (dispatch) => {
    const res = await request.delete(`sys/comp/user/${id}/`)
    console.log(res)
  }
}

/**
 * 批量删除
 * @param {*} values
 * @returns
 */
export const batchDel = (params) => {
  return async (dispatch) => {
    await request.delete('sys/comp/user/', {
      params,
    })
  }
}

/**
 * 重置密码
 * @param {*} values
 * @returns
 */
export const resetPassword = (values) => {
  return async (dispatch) => {
    const res = await request.post('sys/password/reset/', values)
    console.log(res)
  }
}

export const getTrigger = (params, isLoading) => {
  return async (dispatch) => {
    return await request.get('sys/user/check/', {
      params,
      isLoading,
    })
  }
}
